<template>
  <div class="score-page">
    <!-- 頂部標題區域 -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-icon">🎓</div>
        <div class="header-text">
          <h1 class="page-title">{{ yDate }} 學分查詢</h1>
          <p class="page-subtitle">查看您的活動參與記錄與學分獲得情況</p>
        </div>
      </div>
    </div>

    <!-- 統計卡片區域 -->
    <div class="stats-section" v-if="!loading && rsData && rsData.length > 0">
      <div class="stats-card earned-score">
        <div class="stats-icon">✨</div>
        <div class="stats-content">
          <div class="stats-label">實際得分</div>
          <div class="stats-number">{{ total }}</div>
          <div class="stats-caption">累計已獲得學分</div>
        </div>
      </div>
    </div>

    <!-- 主要表格區域 -->
    <div class="table-container">
      <a-card :bordered="false" class="table-card">
        <div class="table-header">
          <h3 class="table-title">📋 活動學分明細</h3>
        </div>
        
        <a-table
          :columns="columns"
          :row-key="record => record.id+record.fid"
          :data-source="rsData"
          :pagination="pagination"
          :loading="loading"
          :locale="{ emptyText: '暫無學分記錄' }"
          :scroll="{ x: 400 }"
          class="score-table"
        >                                     
          <template slot="titles" slot-scope="record">
            <div class="activity-title">
              <a-icon type="star" class="activity-icon" />
              <span>{{ record.acts_signdetail[0].actitle }}</span>
            </div>
          </template>
          
          <template slot="score" slot-scope="record">
            <div class="score-display">
              <span class="score-number">{{ GetScore(record.acts_signdetail) }}</span>
              <span class="score-unit">分</span>
            </div>
          </template>   
          
          <template slot="action" slot-scope="obj">
            <a-button 
              @click="openList(obj)" 
              type="primary" 
              size="small"
              class="detail-btn"
            >
              <a-icon type="eye" class="btn-icon" />
              <span class="btn-text">查看詳情</span>
              <span class="btn-text-mobile">詳情</span>
            </a-button>
          </template>
        </a-table>
      </a-card>
    </div>

    <!-- 美化後的詳細資訊模態視窗 -->
    <a-modal
      v-model="modalVisible"
      title=""
      width="800px"
      :footer="null"
      class="detail-modal"
      centered
    >
      <div v-if="mylists !== null" class="modal-content">
        <!-- 模態視窗標題 -->
        <div class="modal-header">
          <div class="modal-title-icon">📚</div>
          <div class="modal-title-text">
            <h2>{{ mylists.acts_signdetail[0].actitle }}</h2>
            <div class="modal-subtitle">活動學分詳細資訊</div>
          </div>
        </div>

        <!-- 統計資訊 -->
        <div class="modal-stats">
          <div class="modal-stat-item">
            <span class="stat-label">📊 總得分：</span>
            <span class="stat-value">{{ GetScoreByACT(mylists.acts_signdetail) }} 分</span>
          </div>
          <div class="modal-stat-item">
            <span class="stat-label">✅ 實際得分：</span>
            <span class="stat-value earned">{{ GetScoreReal(mylists.acts_signdetail) }} 分</span>
          </div>
          <div class="modal-stat-item">
            <span class="stat-label">📅 出席次數：</span>
            <span class="stat-value">{{ GetJoin(mylists.acts_signdetail) }} 次</span>
          </div>
        </div>

        <!-- 課程詳細列表 -->
        <div class="course-list">
          <h3 class="course-list-title">📝 課程明細</h3>
          <div 
            class="course-item" 
            :class="{ 'attended': element.states === 'Y' }"
            v-for="element in mylists.acts_signdetail" 
            :key="element.id"
          >
            <div class="course-header">
              <div class="course-status">
                {{ element.states === 'Y' ? '✅' : '⭕' }}
              </div>
              <div class="course-info">
                <div class="course-time">
                  📅 {{ element.sdate }} ~ {{ element.edate }}
                </div>
                <div class="course-details">
                  <span class="user-info">👤 {{ element.username }}</span>
                  <span class="role-info">🏷️ {{ getRole(element.roles) }}</span>
                  <span class="score-info">⭐ {{ element.score }} 分</span>
                </div>
              </div>
            </div>
            <div class="course-attendance">
              <span v-if="element.states === 'Y'" class="attended-info">
                ✅ 已報到 | 📍 {{ formatDateTime(element.arrival) }}
              </span>
              <span v-else class="not-attended-info">
                ⭕ 未報到
              </span>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="modal-footer">
          <a-button type="primary" @click="modalVisible = false" size="large">
            <a-icon type="check" />
            確定
          </a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template> 

<script>
import * as moment from "moment/moment";
import { joinService } from "../../_services";

const queryData = params => {
  return joinService.myscores(params) 
};

const columns = [
  {
    title: '🎯 活動名稱',
    dataIndex: '',
    width: 200,
    ellipsis: true,  
    scopedSlots: { customRender: 'titles' },    
  }, 
  {
    title: '⭐ 學分',
    dataIndex: '',
    width: 80,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'score' },    
  },  
  { 
    title: '📋 操作', 
    dataIndex: '', 
    key: 'id',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },  
];

export default {
  name: "Actscore",
  props: {
    useid : Number, 
    yDate : String,
  },
  data() {
    return {
      columns,
      loading: false,
      myJson: [],
      rsData: [],
      mylists: null,
      modalVisible: false,
      spinning: false, 
      total: 0,
      totalAll: 0,
      currentTime: moment(),
      pagination: { 
        defaultPageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 項，共 ${total} 項`
      },
    };
  },
  methods: {

    sortRS(objs){
      return objs.sort((a,b) => (a.sdate > b.sdate))
    },

    getdate(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },

    catImg(imgs) {
      return require(`../../assets/img/${imgs}`);
    },

    getxt(val) {
      return val.substring(0, 32);
    },

    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
    },

    getRole(val){
      let tmp=""
      val=="actor"? tmp="參加者":"";
      val=="broker"? tmp="主辦單位":"";
      val=="coach"? tmp="講師":"";
      val=="volunteer"? tmp="志工":"";
      val=="D"? tmp="下架":"";
      return tmp
    }, 
    
    formatDate(val){
        return moment(val).format("YYYY-MM-DD"); 
    }, 
    formatDateTime(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },       
    shorts(rs){
      return rs.sort((a,b)=>(a.sdate-b.sdate))
    },

    fetch(
      params = {
          id: this.useid,
          date: this.yDate,               
      }) {
      
      this.loading=true
      queryData({
        ...params,
      }).then(({ data }) => {
        this.rsData = data
            if(this.rsData===null){
                this.loading = false
                this.total=0
            }else{
                if(this.rsData.length>0){
                    this.GetTotal()
                }
                this.loading = false
            }

      });
    }, 
    
    GetJoin(obj){
      console.log(obj);
        let tmpArr = obj.filter(
          rs => rs.sid>0
        );
        return tmpArr.length > 0 ? tmpArr.length:0
    },
    GetScore(obj){
        let tmpArr = obj.filter(
          rs => rs.sid>0
        );
        let score =0;
        if(tmpArr.length > 0){
            for(var i in tmpArr){
                score+=tmpArr[i].score
            }
        }
        return score
    },

    GetScoreByACT(obj){
        let tmpArr = obj.filter(
          rs => rs.sid>=0
        );
        let score =0;
        if(tmpArr.length > 0){
            for(var i in tmpArr){
                score+=tmpArr[i].score
            }
        }
        return score
    },    
    
    GetScoreReal(obj){
        let tmpArr = obj.filter(
          rs => rs.sid>0
        );
        let score =0;
        if(tmpArr.length > 0){
            for(var i in tmpArr){
                score+=tmpArr[i].score
            }
        }
        return score
    },    

    GetScores(obj){
        if(obj.length>0){
            return this.total
        }else{
            return 0
        }
    },

    async GetTotal(){
        this.total = 0
        this.totalAll = 0
        if(this.rsData.length > 0){
            for(var i in this.rsData){
                for(var j in this.rsData[i].acts_signdetail){
                    this.totalAll += this.rsData[i].acts_signdetail[j].score
                    if(this.rsData[i].acts_signdetail[j].sid>0){
                        this.total += this.rsData[i].acts_signdetail[j].score
                    }
                }
            }
        }       
    },

    openList(obj){
        this.modalVisible = true
        this.mylists = obj
    } 
    
  },
  created() {}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.score-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px;
}

/* 頂部標題區域 */
.page-header {
  margin-bottom: 30px;
}

.header-content {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 25px 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 1200px;
  margin: 0 auto;
}

.header-icon {
  font-size: 48px;
  margin-right: 20px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-10px); }
  60% { transform: translateY(-5px); }
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  font-size: 16px;
  color: #7f8c8d;
  margin: 5px 0 0 0;
  font-weight: 500;
}

/* 統計卡片區域 */
.stats-section {
  margin-bottom: 30px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.stats-card {
  background: linear-gradient(135deg, #ffffff 0%, #f7f9ff 100%);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.12);
  border: 1px solid rgba(102, 126, 234, 0.12);
  transition: all 0.3s ease;
  min-height: 200px;
}

.stats-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(102, 126, 234, 0.18);
}

.stats-icon {
  font-size: 36px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdf6b, #ffb347);
  margin-bottom: 16px;
  box-shadow: 0 8px 24px rgba(255, 179, 71, 0.25);
}

.stats-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stats-number {
  font-size: 40px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 8px;
  color: #2c3e50;
  letter-spacing: 0.02em;
}

.stats-label {
  font-size: 16px;
  color: #6b7280;
  font-weight: 700;
  margin-bottom: 6px;
  letter-spacing: 0.04em;
}

.stats-caption {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
}

.earned-score .stats-number { color: #2b8a3e; }

@media (max-width: 576px) {
  .stats-card {
    padding: 24px 18px;
    min-height: 180px;
  }

  .stats-number {
    font-size: 32px;
  }
}

/* 表格容器 */
.table-container {
  max-width: 1200px;
  margin: 0 auto;
}

.table-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: visible;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.table-header {
  padding: 25px 30px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
}

.table-title {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

/* 表格樣式 */
.score-table {
  background: transparent;
}

.score-table ::v-deep .ant-table {
  background: transparent;
}

.score-table ::v-deep .ant-table-thead > tr > th {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  font-weight: 600;
  font-size: 16px;
  padding: 16px 20px;
}

.score-table ::v-deep .ant-table-tbody > tr {
  transition: all 0.3s ease;
}

.score-table ::v-deep .ant-table-tbody > tr:hover {
  background: rgba(102, 126, 234, 0.05);
  transform: scale(1.01);
}

.score-table ::v-deep .ant-table-tbody > tr > td {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
  font-size: 15px;
}

/* 活動標題樣式 */
.activity-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #2c3e50;
}

.activity-icon {
  color: #f39c12;
  margin-right: 10px;
  font-size: 16px;
}

/* 學分顯示樣式 */
.score-display {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.score-number {
  font-size: 18px;
  color: #27ae60;
  margin-right: 4px;
}

.score-unit {
  font-size: 14px;
  color: #7f8c8d;
}

/* 詳情按鈕 */
.detail-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 80px;
}

.detail-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* 按鈕文字控制 */
.detail-btn .btn-text {
  display: inline;
}

.detail-btn .btn-text-mobile {
  display: none;
}

.detail-btn .btn-icon {
  margin-right: 4px;
}

/* 模態視窗樣式 */
.detail-modal ::v-deep .ant-modal-content {
  border-radius: 20px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.detail-modal ::v-deep .ant-modal-header {
  display: none;
}

.modal-content {
  padding: 30px;
}

.modal-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.modal-title-icon {
  font-size: 40px;
  margin-right: 20px;
}

.modal-title-text h2 {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.modal-subtitle {
  font-size: 14px;
  color: #7f8c8d;
  margin-top: 5px;
}

/* 模態視窗統計 */
.modal-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.modal-stat-item {
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #667eea;
  transition: all 0.3s ease;
}

.modal-stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
}

.stat-value.earned {
  color: #27ae60;
}

/* 課程列表 */
.course-list {
  margin-top: 30px;
}

.course-list-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.course-item {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border-left: 4px solid #e74c3c;
  transition: all 0.3s ease;
}

.course-item.attended {
  border-left-color: #27ae60;
  background: rgba(46, 204, 113, 0.05);
}

.course-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.course-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.course-status {
  font-size: 24px;
  margin-right: 15px;
  flex-shrink: 0;
}

.course-info {
  flex: 1;
}

.course-time {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.course-details {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 14px;
}

.user-info, .role-info, .score-info {
  color: #7f8c8d;
  font-weight: 500;
}

.course-attendance {
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  margin-top: 12px;
}

.attended-info {
  color: #27ae60;
  font-weight: 600;
}

.not-attended-info {
  color: #e74c3c;
  font-weight: 600;
}

/* 模態視窗底部 */
.modal-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(102, 126, 234, 0.1);
}

.modal-footer .ant-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 8px;
  padding: 0 30px;
  height: 40px;
  font-weight: 500;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .score-page {
    padding: 15px;
  }
  
  .header-content {
    padding: 20px;
    flex-direction: column;
    text-align: center;
  }
  
  .header-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .stats-cards {
    grid-template-columns: 1fr;
  }
  
  .course-details {
    flex-direction: column;
    gap: 8px;
  }
  
  .modal-content {
    padding: 20px;
  }
  
  .modal-stats {
    grid-template-columns: 1fr;
  }
  
  /* 手機版表格優化 */
  .score-table ::v-deep .ant-table {
    font-size: 14px;
  }
  
  .score-table ::v-deep .ant-table-thead > tr > th {
    padding: 12px 8px;
    font-size: 14px;
  }
  
  .score-table ::v-deep .ant-table-tbody > tr > td {
    padding: 12px 8px;
    font-size: 14px;
  }
  
  /* 表格滾動時的樣式優化 */
  .score-table ::v-deep .ant-table-body {
    overflow-x: auto;
  }
  
  /* 手機版按鈕文字控制 */
  .detail-btn .btn-text {
    display: none;
  }
  
  .detail-btn .btn-text-mobile {
    display: inline;
  }
  
  .detail-btn {
    min-width: 70px;
    padding: 4px 8px;
    font-size: 12px;
  }
  
  .detail-btn .btn-icon {
    margin-right: 2px;
    font-size: 12px;
  }
  
  /* 活動標題在手機版的調整 */
  .activity-title {
    font-size: 14px;
    line-height: 1.4;
  }
  
  .activity-icon {
    font-size: 14px;
    margin-right: 6px;
  }
  
  /* 學分顯示在手機版的調整 */
  .score-display {
    font-size: 14px;
  }
  
  .score-number {
    font-size: 16px;
  }
  
  /* 表格卡片在手機版的調整 */
  .table-card {
    margin: 0 -5px;
    border-radius: 12px;
  }
  
  .table-header {
    padding: 20px 15px 15px;
  }
  
  .table-title {
    font-size: 18px;
  }
}

/* 載入動畫 */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.ant-spin-container {
  animation: pulse 1.5s ease-in-out infinite;
}
</style>





